import { Plugin, PluginKey, Transaction } from '@tiptap/pm/state'
import { EditorView } from '@tiptap/pm/view'
import { Slice } from '@tiptap/pm/model'
import { Editor, Extension } from '@tiptap/core'

// Types for handlers
export interface PasteHandlerResult {
  handled: boolean
  modifications?: Array<(tr: Transaction) => Transaction>
  preventDefault?: boolean
}

export interface PasteHandler {
  priority: number
  handler: (props: {
    editor: Editor
    view: EditorView
    event: ClipboardEvent
    slice: Slice
  }) => PasteHandlerResult
}

export const PASTE_PRIORITIES = {
  HIGHEST: 1000,
  LINK: 950,
  FILE: 900,
  IMAGE: 800,
  VIDEO: 700,
  BLOCK: 600,
  HEADING: 500,
  CONTENT: 400,
  TRANSFORM: 300,
  DEFAULT: 100,
} as const

// Extension that accepts handlers through configuration
export interface PasteHandlerExtensionOptions {
  handlers: PasteHandler[]
}
export const PasteHandlerExtension =
  Extension.create<PasteHandlerExtensionOptions>({
    name: 'pasteHandler',

    addProseMirrorPlugins() {
      const { handlers } = this.options

      // Sort handlers by priority
      const sortedHandlers = [...handlers].sort(
        (a, b) => b.priority - a.priority
      )

      return [
        new Plugin({
          key: new PluginKey('pasteHandler'),
          props: {
            handlePaste: (view, event, slice) => {
              for (const { handler } of sortedHandlers) {
                const result = handler({
                  editor: this.editor,
                  view,
                  event,
                  slice,
                })

                if (result.handled) {
                  if (result.preventDefault) {
                    event.preventDefault()
                  }
                  return true
                }
              }
              return false
            },
          },
        }),
      ]
    },
  })
